/* eslint-disable */
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { components } from "react-select";
import { setLiveImagesrc, showImageSignatureFlag } from "../../candidate_profile_creation/actions/profileAction";
import ImageCropper from '../../candidate_profile_creation/components/imageCropper';
import profileuploadphotosignature from '../../candidate_profile_creation/labels/upload_photo_and_signature_en.json';
import { getOTRdetails, hideLoader, showLoader } from '../../common/actions/commonActions';
import { getResizedImage } from '../../helpers/ImageHelper';
import "../../styles/advertisement.css";
import {
  closePaymentModal,
  doApply,
  doPayment,
  downloadAdvertisementPdf,
  downloadDocument,
  getAdvertisementDetails,
  getAllDepartments,
  getCheckEligibility,
  getDepartments,
  getUploadDocument,
  postUploadDocument,
  resetApplicationPostPref,
  resetUploadeDocumentChecks,
} from "../actions/advertisementAction";
import advertisementDetailsLabel from "../labels/advertisement_details_en.json";
import DocumentList from "./DocumentList";
import ProfileDetails from "./ProfileDetails";
import ReviewSelectedModal from "./ReviewSelectedModal";

import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { getFormattedDate } from "../../helpers/Datetime";
import commonLabels from "../../my_account/labels/common_en.json";
import myAccountLabels from "../../my_account/labels/my_account_en.json";

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);
  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: "inherit",
    display: "flex ",
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };
  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <input type="checkbox" className="me-2" checked={isSelected} />
      {children}
    </components.Option>
  );
};
const AdvertisementDetails = ({ setName }) => {
  const defaultImage = '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';
  const [dummy, setDummy] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [selectedExamCenters, setSelectedExamCenters] = useState("");
  const [declAccepted, setDeclAccepted] = useState(false);
  const [allDeclAccepted, setAllDeclAccepted] = useState(false);
  const [additionalAnswers, additionalAnswersState] = useState([]);
  // const [location, setLocation] = useState("");
  const [flgDisabilityCompTime, setFlgDisabilityCompTime] = useState("");
  const [flgDisabilityScribeReq, setFlgDisabilityScribeReq] = useState("");
  const [scribeArrangedBy, setScribeArrangedBy] = useState("");
  const [showDocListModal, setshowDocListModal] = useState(false);
  const [singleDocList, setSingleDocList] = useState("");
  let [showChallan, setShowChallan] = useState(true);
  let [showOnlinePayment, setShowOnlinePayment] = useState(true);
  let [showSbi, setShowSbi] = useState(true);
  let [showBillDesk, setShowBillDesk] = useState(true);
  let [showEaseBuzz, setShowEaseBuzz] = useState(true);
  let [showCsc, setShowCsc] = useState(true);
  let [showQuickwallet, setShowQuickwallet] = useState(true);
  const [selectedOptionErr, setSelectedOptionErr] = useState(false);
  const [selectedDepartmentArr, setSelectedDepartmentArr] = useState([]);
  const [selectedTempDepartmentArr, setSelectedTempDepartmentArr] = useState([]);
  const [reviewDepartmentModal, setReviewDepartmentModal] = useState(false);
  const [deptOptions, setDeptOptions] = useState([]);
  const [currentPostId, setOpenModelPostid] = useState([]);
  const [reloadItem, setReloadItem] = useState(0);
  const [someOptionsThisPost, setSomeOptionsThisPost] = useState([]);
  const [showSuccessLivePhotoModal, setShowSuccessLivePhotoModal] = useState(false);
  const [isCheckboxMarked, SetIsCheckboxMarked] = useState(false);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [showName, setShowName] = useState(false)
  const webcamRef = React.useRef(null);
  let [errorLivePhoto, setErrorLivePhoto] = useState("");
  const [intervalId, setIntervalId] = useState(null);
  const [timer, setTimer] = useState(10)
  const [uploadLiveImage, setUploadLiveImage] = useState({
    showCandidatePhoto: "",
    sendCandidatePhotoFile: "",
    showCandidatePhotoBase64: "",
    defaultCandidatePhoto: defaultImage
  })
  const dispatch = useDispatch();

  const { register, formState, watch } = useForm({
    mode: "onChange",
  });

  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  const { isApplicationLivePhotoEnable } = useSelector((state) => state.advertisement, shallowEqual)
  const { otrDetails } = useSelector(state => state.common, shallowEqual);

  let {
    advertisementDetailsInfo,
    advertisementId,
    eligibilityResultList,
    applicableAdditionalQuestionsList,
    applicationPostPrefList,
    examCenterOptionList,
    profileInfo,
    applicationFee,
    proceedToPayment,
    applyedApplication,
    uploadedDocumentData,
    setCheckEligibilty,
    allDepartments,
    allPostsDepartments,
    isCenterSelection,
    maxCenterSelectionNumber,
    applicationFeeWithoutConcession,
  } = useSelector((state) => state.advertisement, shallowEqual);

  const popupName = () => {
    setShowName(true);
    setIsCameraOn(false);
    if (intervalId) {
      clearInterval(intervalId); // Clear any existing interval before starting a new one
    }

    // let countdown = 10; // Reset timer value
    setTimer(session.livePhotoCaptureTimer);

    const newInterval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(newInterval);
          setShowName(false);
          setIsCameraOn(true);
          return 0; // Stop at 0
        }
        return prevTimer - 1;
      });
    }, 1000);
    setIntervalId(newInterval); // Store the interval ID
  };

  const hideModal = () => {
    setShowName(false);
    setIsCameraOn(false);
    setShowSuccessLivePhotoModal(false)
    setTimer(0);

    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  const takePhoto = () => {
    setIsCameraOn(true);
    setShowName(false)
  }

  const capture = React.useCallback(
    async () => {
      const imageSrc = webcamRef.current.getScreenshot();
      const img = imageSrc.split(',')[1];

      let base64Response = await fetch(`data:image/jpeg;base64,${img}`);
      let sendCandidatePhotoFile = await base64Response.blob();
      setUploadLiveImage({
        showCandidatePhotoBase64: img,
        showCandidatePhoto: "",
        sendCandidatePhotoFile: sendCandidatePhotoFile,
        defaultCandidatePhoto: ""
      })
      dispatch(setLiveImagesrc(imageSrc))
      setIsCameraOn(false);
      setShowSuccessLivePhotoModal(true)
    },
    [webcamRef]
  );

  const removeCandidateLiveImage = () => {
    setUploadLiveImage({
      showCandidatePhoto: "",
      showCandidatePhotoBase64: "",
      sendCandidatePhotoFile: "",
      defaultCandidatePhoto: defaultImage
    });
  }
  const showLiveImageCropper = () => {
    dispatch(showImageSignatureFlag(false, true, false))
    setIsCameraOn(false);
  }

  const handleQuestions = (evt) => {
    const value = evt.target.value;
    // additionalAnswersState({
    //   ...additionalAnswers,
    //   [evt.target.name]: value,
    // });

    //   additionalAnswersState([
    //     ...additionalAnswers,
    //     {"id":evt.target.name,"answer":value},
    //     // [evt.target.name]: value,
    // ]);

    // const value = evt.target.value;
    const id = evt.target.name;

    // Update or add the answer with the given id
    additionalAnswersState((prevAnswers) => {
      const updatedAnswers = prevAnswers.map((answer) =>
        answer.id === id ? { ...answer, answer: value } : answer
      );

      // If the id doesn't exist, add a new object to the array
      if (!updatedAnswers.some((answer) => answer.id === id)) {
        updatedAnswers.push({ id, answer: value });
      }

      return updatedAnswers;
    });
  };


  const maximumNoCenter = 1;
  const challanDownloadDate =
    applyedApplication?.challanDownloadEndDate != null
      ? applyedApplication?.challanDownloadEndDate
      : applyedApplication?.applnEndDate;


  const downloadPdfFile = () => {
    dispatch(downloadAdvertisementPdf(advertisementId));
  };

  const checkEligibility = () => {
    dispatch(getCheckEligibility(advertisementId));
  };

  const computeIsEligible = (postCriteriaId) => {
    const eligibilityResult = eligibilityResultList?.find(
      (elgbResult) => elgbResult.postCriteriaId == postCriteriaId
    );
    if (!eligibilityResult) {
      return null;
    }
    return eligibilityResult.isEligible;
  };

  const computeIsEligibleMsg = (postCriteriaId) => {
    const eligibilityResult = eligibilityResultList?.find(
      (elgbResult) => elgbResult.postCriteriaId == postCriteriaId
    );
    if (!eligibilityResult) {
      return null;
    }
    return eligibilityResult.message;
  };

  const getElibilityIndicator = (postCriteriaId) => {
    const isEligible = computeIsEligible(postCriteriaId);
    const message = computeIsEligibleMsg(postCriteriaId);
    const text = message && message.split("\n");
    if (isEligible == null) {
      return;
    }
    return isEligible ? (
      <span className="text-success">{advertisementDetailsLabel.YouAreEligiblePost}</span>
    ) : (
      <span className="text-danger">
        <p className="text-danger">
          {advertisementDetailsLabel.YouAreNotEligiblePost}
        </p>{" "}
        {text.map((ele, i) => (
          <p key={i} className="mb-n1">
            {ele}
          </p>
        ))}
      </span>
    );
  };

  const getPostName = (postCriteriaId, isDvng) => {
    const examPost = advertisementDetailsInfo?.data?.examPostList?.find(
      (examPost) => examPost.postCriteria.id == postCriteriaId
    );
    if (!examPost) {
      return `Unknown (${postCriteriaId})`;
    }
    return isDvng ? examPost.postCriteria.nameDvng : examPost.postCriteria.name;
  };

  const nextApply = () => {
    setIsNext(true);
    let post = applicationPostPrefList
      .filter((pref) => pref.isInterested)
      .map((pref, index) => ({ ...pref, prefOrder: index + 1 }));
    dispatch(getUploadDocument(advertisementId, post, setName));
  };

  const doNext = () => {
    nextApply();
  };

  const handlePrefChange = (postPref, name, value, postCritId) => {
    postPref[name] = value;
    setDummy(dummy + 1);
    const newArr = [];
    applicationPostPrefList.find((e) => {
      if (e.isInterested == true && e.isAssignAuthority == true) {
        newArr.push(e.postCriteriaId);
      } else if (e.isInterested == false && e.isAssignAuthority == true) {
        removeFromSelectedDeptArray(postPref);
        let uniqueChars = [];
        someOptionsThisPost.forEach((c) => {
          if (!uniqueChars.includes(c)) {
            setSomeOptionsThisPost(uniqueChars);
          }
        });
      }
    });
    if (
      newArr.length > 0 &&
      someOptionsThisPost &&
      someOptionsThisPost.indexOf(postCritId) != -1
    ) {
      setSelectedOptionErr(false);
    } else if (newArr.length > 0) {
      setSelectedOptionErr(true);
    } else {
      setSelectedOptionErr(false);
    }
    deptOptions
      .filter((ele) => ele.pid == postCritId)
      .map((elem, index) => {
        if (
          elem.options.mumbai.length == 0 &&
          elem.options.outsideMumbai.length == 0
        ) {
          setSelectedOptionErr(false);
        }
      });
    if (postPref.isInterested === false) {
      removeFromSelectedDeptArray(postPref);
    }

    if (postPref.isAssignAuthority === true && postPref.isInterested === true) {
      dispatch(getDepartments(postPref.postCriteriaId));
    }
    applicationPostPrefList.filter((e) => {
      if (e.postCriteriaId === postPref.postCriteriaId) {
        if (
          (e.isInterested == false && (e.isAssignAuthority == true || e.isAssignAuthority == false) &&
            e.preferredAppointingAuthorities) ||
          (e.isInterested == true && e.isAssignAuthority == false &&
            !e.preferredAppointingAuthorities)
        ) {
          setSelectedOptionErr(true);
        } else if (
          (e.isInterested == true && e.isAssignAuthority == true
            &&
            !e.preferredAppointingAuthorities) ||
          e.isInterested == false
        ) {
          setSelectedOptionErr(false);
        }
      } else if (e.postCriteriaId !== postPref.postCriteriaId) {
        if (
          e.isInterested == true && e.isAssignAuthority == true
          &&
          !e.preferredAppointingAuthorities
        ) {
          setSelectedOptionErr(false);
        }
      }
      if (
        e.isInterested == true && e.isAssignAuthority == true
        &&
        someOptionsThisPost.length <= 0
      ) {
        setSelectedOptionErr(false);
      }
    });

    SetIsCheckboxMarked(!isCheckboxMarked)
  };

  const handleDocChange = (doc, isUploaded, value) => {
    doc[isUploaded] = value;
    setDummy(dummy + 1);
  };

  const removeFromSelectedDeptArray = (postData) => {
    let newArray =
      selectedTempDepartmentArr &&
      selectedTempDepartmentArr.filter(
        (eleN) => eleN.pid != postData.postCriteriaId
      );
    setSelectedTempDepartmentArr(newArray);
  };

  function convertBooleanAnswersToYesNo(answerList) {
    return answerList.map(answer => {
      if (answer.answer === "true") {
        answer.answer = true;
      } else if (answer.answer === "false") {
        answer.answer = false;
      }
      return answer;
    });
  }

  const applyInfo = async (location, validQuestionList) => {
    const foundTrueValue =
      uploadedDocumentData &&
      uploadedDocumentData.find((element) => !element.isUploaded);
    if (foundTrueValue) {
      toastr.error(advertisementDetailsLabel.UPLOAD_DOC_INFO_NOTE);
    } else {
      let additionalAnswers1;
      if (additionalAnswers.length == 0) {
        additionalAnswers1 = null;
      } else {
        let emptyQuestions = []
        if (applicableAdditionalQuestionsList) {
          for (const ques of applicableAdditionalQuestionsList) {
            let found = additionalAnswers.find((question) => question.id === ques.id)
            if (!found) {
              emptyQuestions.push({ id: ques.id, answer: '' })
            }
          }
        }
        let answerList = [...additionalAnswers, ...emptyQuestions];
        // console.log('additionalAnswers1 check',additionalAnswers1);
        //   let getUpdatedList = additionalAnswers1.forEach(record => {
        //     // Only change the key if `answer` exists and is an array
        //     if (record.answer && Array.isArray(record.answer)) {
        //         record.answers = record.answer;
        //         delete record.answer;  // Remove the old 'answer' key
        //     }
        // });
        additionalAnswers1 = answerList.map(record => {
          if (record.answer && Array.isArray(record.answer)) {
            return { ...record, answers: record.answer, answer: undefined }; // Create a new object with `answers` key and delete the old `answer` key
          }
          return record; // If `answer` is not an array, just return the original record
        });
      }
      let livePhotoBlob = uploadLiveImage.sendCandidatePhotoFile;
      if (livePhotoBlob === "" || livePhotoBlob.type === 'text/html') {
        setErrorLivePhoto(profileuploadphotosignature.LIVE_PHOTO_REQUIRED);
      }
      let data = {
        livephoto: await getResizedImage(livePhotoBlob)
      }
      let newApplicationPostPrefList = [];
      applicationPostPrefList && applicationPostPrefList.map((ele, ind) => {
        delete ele.isAssignAuthority;
        newApplicationPostPrefList.push(ele);
      });
      const isOptedOutConcessionFeeFlag = additionalAnswers && additionalAnswers.length > 0 && additionalAnswers.some(item => item.id === "QueConcessionFeeOptOut" && item.answer === "true");

      const applnData = {
        advertisementId,
        location,
        additionalAnswers: additionalAnswers1 ? JSON.stringify(convertBooleanAnswersToYesNo(additionalAnswers1)) : "",
        applicationPostPrefList: newApplicationPostPrefList
          .filter((pref) => pref.isInterested)
          .map((pref, index) => ({
            ...pref,
            prefOrder: index + 1,
            preferredAppointingAuthorities:
              selectedDepartmentArr.length > 0
                ? JSON.stringify(
                  selectedDepartmentArr
                    .filter((ele) => ele.pid == pref.postCriteriaId)
                    .map(
                      (elem) =>
                        elem.selectedDepartment &&
                        elem.selectedDepartment.length > 0 &&
                        elem.selectedDepartment.map((dep) => dep.id)
                    )[0]
                )
                : null,
          })),
        applicationExamCenterPrefList: selectedExamCenters && selectedExamCenters.length > 0 ? selectedExamCenters.map(
          (examCenterOption) => ({ examCenterId: examCenterOption.value })
        ) : [],
        flgDisabilityCompTime,
        flgDisabilityScribeReq,
        scribeArrangedBy,
        amountPayable: applicationFee,
        requiredDocumentsSelected: uploadedDocumentData.map((doc) => ({
          ...doc,
          documentInfoId: doc.isUploaded ? doc.documentInfoId : null,
        })),
        additionalQuestions: validQuestionList ? JSON.stringify(validQuestionList) : "",
        isOptedOutConcessionFee: isOptedOutConcessionFeeFlag
      };
      // return
      dispatch(doApply(applnData, data, isApplicationLivePhotoEnable, setName));
      const enabledPaymentMethods = advertisementDetailsInfo &&
        advertisementDetailsInfo.data &&
        advertisementDetailsInfo.data.advertisementConfig &&
        advertisementDetailsInfo.data.advertisementConfig
          .enabledPaymentMethods ? JSON.parse(
            advertisementDetailsInfo &&
            advertisementDetailsInfo.data &&
            advertisementDetailsInfo.data.advertisementConfig &&
            advertisementDetailsInfo.data.advertisementConfig
              .enabledPaymentMethods
          ) : "";

      const disabledPaymentMethods = advertisementDetailsInfo &&
        advertisementDetailsInfo.data &&
        advertisementDetailsInfo.data.advertisementConfig &&
        advertisementDetailsInfo.data.advertisementConfig
          .disabledPaymentMethods ? JSON.parse(
            advertisementDetailsInfo &&
            advertisementDetailsInfo.data &&
            advertisementDetailsInfo.data.advertisementConfig &&
            advertisementDetailsInfo.data.advertisementConfig
              .disabledPaymentMethods
          ) : "";

      if (enabledPaymentMethods) {
        setShowChallan(enabledPaymentMethods.includes("challan"));

        setShowOnlinePayment(
          enabledPaymentMethods.includes("sbiepay") ||
          enabledPaymentMethods.includes("billdesk") ||
          enabledPaymentMethods.includes("csc") ||
          enabledPaymentMethods.includes("easebuzz") ||
          enabledPaymentMethods.includes("quikwallet")
        );

        setShowSbi(enabledPaymentMethods.includes("sbiepay"));
        setShowBillDesk(enabledPaymentMethods.includes("billdesk"));
        setShowEaseBuzz(enabledPaymentMethods.includes("easebuzz"));
        setShowQuickwallet(enabledPaymentMethods.includes("quikwallet"));
        setShowCsc(enabledPaymentMethods.includes("csc"));
      }
      if (disabledPaymentMethods) {
        setShowChallan(!disabledPaymentMethods.includes("challan"));

        setShowOnlinePayment(
          !disabledPaymentMethods.includes("sbiepay") ||
          !disabledPaymentMethods.includes("billdesk") ||
          !disabledPaymentMethods.includes("csc") ||
          !disabledPaymentMethods.includes("quikwallet") ||
          !disabledPaymentMethods.includes("easebuzz")
        );

        setShowSbi(!disabledPaymentMethods.includes("sbiepay"));
        setShowBillDesk(!disabledPaymentMethods.includes("billdesk"));
        setShowEaseBuzz(!disabledPaymentMethods.includes("easebuzz"));
        setShowQuickwallet(!disabledPaymentMethods.includes("quikwallet"));
        setShowCsc(!disabledPaymentMethods.includes("csc"));
      }
    }
  };

  const onApply = (location, validQuestionList) => {
    applyInfo(location, validQuestionList);
  };

  const goBack = () => {
    setSelectedExamCenters("");
    setDeclAccepted(false);
    setAllDeclAccepted(false);
    SetIsCheckboxMarked(false);
    // setLocation("");
    setFlgDisabilityCompTime("");
    setFlgDisabilityScribeReq("");
    setScribeArrangedBy("");
    setIsNext(false);
    dispatch(resetUploadeDocumentChecks());
  };

  const movePostPrefUp = (index) => {
    if (index == 0) return;
    const tmp = applicationPostPrefList[index];
    applicationPostPrefList[index] = applicationPostPrefList[index - 1];
    applicationPostPrefList[index - 1] = tmp;
    setDummy(dummy + 1);
  };

  const movePostPrefDown = (index) => {
    if (index >= applicationPostPrefList.length) return;
    const tmp = applicationPostPrefList[index];
    applicationPostPrefList[index] = applicationPostPrefList[index + 1];
    applicationPostPrefList[index + 1] = tmp;
    setDummy(dummy + 1);
  };

  const resetPref = () => {
    dispatch(resetApplicationPostPref());
    setSelectedDepartmentArr([]);
    setSomeOptionsThisPost([]);
  };

  const onChangeDocument = (event, doc) => {
    const file = event.target.files[0];
    if (!file) return;
    const maxSizeInBytes = commonENLabels.COMMON.UPLOAD_DOCUMENT_SIZE_VALUE * commonENLabels.COMMON.ONE_KB_VALUE;
    if (file.size > maxSizeInBytes) {
      toastr.error(commonENLabels.COMMON.FILE_SIZE_150_KB_ERR_MES);
      event.target.value = "";
      return;
    }

    let post = applicationPostPrefList
      .filter((pref) => pref.isInterested)
      .map((pref, index) => ({ ...pref, prefOrder: index + 1 }));
    if (event.target.files.length == 0) {
      return;
    }
    let requestBody = {};
    requestBody.uploadPdfDoc = event.target.files[0];
    requestBody.documentTypeId = doc.documentTypeId;
    dispatch(postUploadDocument(requestBody, advertisementId, post));
  };

  const viewDocument = (doc) => {
    dispatch(downloadDocument(doc.documentInfoId, doc.documentTypeName, otrDetails?.oneTimeRegistrationNo));
  };

  const handleDocumentListShow = (docList) => {
    setshowDocListModal(true);
    setSingleDocList(docList);
  };

  const processToPayment = (paymentData, paymenttype) => {
    let data = {};
    data.paymentBank = watch("paymentBank");
    if (paymenttype) {
      dispatch(doPayment(paymentData.applicationId, paymenttype, data));
    }
    dispatch(closePaymentModal(false));
  };

  const handleOptionsChange = (value, postPrefId) => {
    const tempArr = [];
    if (value.length > 0) {
      setSelectedOptionErr(true);
      value.map((e) => {
        if (e.id) {
          tempArr.push(e.id);
        }
      });

      let alreadyArray =
        selectedTempDepartmentArr &&
        selectedTempDepartmentArr.filter((eleN) => eleN.pid == postPrefId);
      if (alreadyArray.length > 0) {
        let newArray = [];
        selectedTempDepartmentArr &&
          selectedTempDepartmentArr.length > 0 &&
          selectedTempDepartmentArr.map((eleNN, index) => {
            if (eleNN.pid == postPrefId) {
              let arrDep = {
                pid: eleNN.pid,
                selectedDepartment: value,
              };

              newArray.push(arrDep);
            } else {
              newArray.push(eleNN);
            }
          });

        setSelectedTempDepartmentArr(newArray);
      } else {
        let arrDep = {
          pid: postPrefId,
          selectedDepartment: value,
        };
        setSelectedTempDepartmentArr((arr) => [...arr, arrDep]);
      }

      applicationPostPrefList &&
        applicationPostPrefList.map((e) => {
          if (e.postCriteriaId === postPrefId) {
            e.preferredAppointingAuthorities = JSON.stringify(tempArr);
          } else {
            e.preferredAppointingAuthorities = null;
          }
        });

      setSomeOptionsThisPost((arr) => [...arr, postPrefId]);
      setReloadItem(!reloadItem);
      if (value.length > 0) {
        setSelectedOptionErr(true);
      } else {
        setSelectedOptionErr(false);
      }
    } else {
      setSelectedOptionErr(false);
      let newOption =
        someOptionsThisPost &&
        someOptionsThisPost.filter((eleN) => eleN != postPrefId);
      let newArray =
        selectedTempDepartmentArr &&
        selectedTempDepartmentArr.filter((eleN) => eleN.pid != postPrefId);

      setSomeOptionsThisPost(newOption);

      setSelectedTempDepartmentArr(newArray);
      setReloadItem(!reloadItem);
    }

    deptOptions
      .filter((ele) => ele.pid == postPrefId)
      .map((elem, index) => {
        if (elem.pid == postPrefId) {
          if (
            elem.options.isMultiple === true &&
            elem.options.isSelectAny === false
          ) {
            if (value.length > 0) {
              const upatedVal = value;
              upatedVal.map((e) => {
                elem.options.mumbai.map((ele, index) => {
                  if (ele.id === e.id && ele.isDisable === false) {
                    elem.options.outsideMumbai.map((ele) => {
                      ele.isDisable = true;
                    });
                  }
                });
                elem.options.outsideMumbai.map((ele) => {
                  if (ele.id === e.id && ele.isDisable === false) {
                    elem.options.mumbai.map((ele) => {
                      ele.isDisable = true;
                    });
                  }
                });
              });
            } else {
              elem.options.mumbai.map((ele) => {
                ele.isDisable = false;
              });
              elem.options.outsideMumbai.map((ele) => {
                ele.isDisable = false;
              });
            }
          } else if (
            elem.options.isMultiple === false &&
            elem.options.isSelectAny === true
          ) {
            if (value.length > 0) {
              const upatedVal = value;
              upatedVal.map((e) => {
                elem.options.mumbai.map((ele) => {
                  if (ele.id === e.id && ele.isDisable === false) {
                    elem.options.outsideMumbai.map((ele) => {
                      ele.isDisable = true;
                    });
                  } else {
                    ele.isDisable = true;
                  }
                });
                elem.options.outsideMumbai.map((ele) => {
                  if (ele.id === e.id && ele.isDisable === false) {
                    elem.options.mumbai.map((ele) => {
                      ele.isDisable = true;
                    });
                  } else {
                    ele.isDisable = true;
                  }
                });
              });
            } else {
              elem.options.mumbai.map((ele) => {
                ele.isDisable = false;
              });
              elem.options.outsideMumbai.map((ele) => {
                ele.isDisable = false;
              });
            }
          }
        }
      });
    if (tempArr.length <= 0) {
      toastr.error(
        advertisementDetailsLabel.PLEASE_SELECT_APPOINTING_AUTHORITY
      );
      setSelectedOptionErr(false);
    }
  };

  const handleMenuClick = () => {
    if (allDepartments.length === 0) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  };

  const showReviewDepartmentModal = (postCriteriaId) => {
    setOpenModelPostid(postCriteriaId);
    setReviewDepartmentModal(true);
    setReloadItem(!reloadItem);
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
    </div>
  );

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#007bff",
    fontWeight: "600",
  };


    useEffect(() => {
    setDeptOptions([]);
    applicationPostPrefList &&
      applicationPostPrefList?.map((postPref, index) => {
        allPostsDepartments?.map((pos, ind) => {
          if (pos.postCriteriaId == postPref.postCriteriaId) {
            let opt = {
              pid: postPref.postCriteriaId,
              options: pos.appointintAuthorities,
            };
            setDeptOptions((arr) => [...arr, opt]);
          }
        });
      });
  }, [allPostsDepartments, applicationPostPrefList]);


  useEffect(() => {
    dispatch(getAdvertisementDetails(advertisementId));
    dispatch(getAllDepartments(advertisementId));
  }, []);
  useEffect(() => {
    dispatch(getOTRdetails())
  }, []);

    useEffect(() => { }, [reloadItem]);

      useEffect(() => {
    setSelectedDepartmentArr(selectedTempDepartmentArr);
  }, [selectedTempDepartmentArr]);


  return (
    <div className="advertisement_container f12 mb-4 b-w pt-2">
      <div className="box-one" id="hide_Block">
        <h6 className="blue_box">
          <img className="tabHeadingLogo" src="/icons/my_account.png" />
          {commonENLabels.NEW_APPLICATION.NEW_APPLICATION}
          {commonHILabels.NEW_APPLICATION.NEW_APPLICATION}
        </h6>
      </div>
      <div className="row d-flex justify-content-center p-0 m-0">
        <div className="col-md-12 pe-0">
          <div className="row row box-contents tab_container_box m-3 f12">
            <div className="col-md-8 ">
              <div className="row ">
                <div className="col-md-8 fw-bold">
                  {commonENLabels.NEW_APPLICATION.Advertisement_No}{" "}
                  {advertisementDetailsInfo.data &&
                    advertisementDetailsInfo.data.advertisement
                    ? advertisementDetailsInfo.data.advertisement
                      .advertisementNo
                    : ""}{"/"}{advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement
                      ? advertisementDetailsInfo.data.advertisement
                        .year
                      : ""}&nbsp;
                  ({commonHILabels.NEW_APPLICATION.Advertisement_No}{" "}
                  {advertisementDetailsInfo.data &&
                    advertisementDetailsInfo.data.advertisement
                    ? advertisementDetailsInfo.data.advertisement
                      .advertisementNo
                    : ""}{"/"}{advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement
                      ? advertisementDetailsInfo.data.advertisement
                        .year
                      : ""}
                  )
                </div>
              </div>
              <div className="my-2 full-width-bottom-blue-border"></div>
              <span className="fw-bold">
                {advertisementDetailsInfo.data &&
                  advertisementDetailsInfo.data.advertisement
                  ? advertisementDetailsInfo.data.advertisement.name
                  : ""}{" "}
                |{" "}
                {advertisementDetailsInfo.data &&
                  advertisementDetailsInfo.data.advertisement
                  ? advertisementDetailsInfo.data.advertisement.nameDvng
                  : ""}{" "}
              </span>
              <br />
              <br />
              <br />
              <div className="row ">
                <span className="fw-bold">
                  {" "}
                  {commonENLabels.NEW_APPLICATION.EXAMINATION}{" "}
                  {advertisementDetailsInfo.data &&
                    advertisementDetailsInfo.data.advertisement &&
                    advertisementDetailsInfo.data.advertisement.exam
                    ? advertisementDetailsInfo.data.advertisement.exam.name
                    : ""}
                </span>
                <span className="fw-bold">
                  {" "}
                  ({commonHILabels.NEW_APPLICATION.EXAMINATION}{" "}
                  {advertisementDetailsInfo.data &&
                    advertisementDetailsInfo.data.advertisement
                    ? advertisementDetailsInfo.data.advertisement.nameDvng
                    : ""}
                  )
                </span>
                <br />
                <br />
              </div>
            </div>
            <div className="col-md-4 border-left-blue">
              <div className="row">
                <div className="d-flex">
                  <span className="fw-bold">
                    {commonENLabels.NEW_APPLICATION.Start_Date_Application}
                  </span>
                  <span>
                    {advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement &&
                      advertisementDetailsInfo.data.advertisement.applnStartDate
                      ? dayjs(
                        getFormattedDate(advertisementDetailsInfo.data.advertisement
                          .applnStartDate)
                      ).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </span>
                </div>
                <div className="d-flex mt-1">
                  <span className="fw-bold">
                    {commonENLabels.NEW_APPLICATION.Last_Date_Application}
                  </span>
                  <span>
                    {advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement &&
                      advertisementDetailsInfo.data.advertisement.applnEndDate
                      ? dayjs(
                        getFormattedDate(advertisementDetailsInfo.data.advertisement
                          .applnEndDate)
                      ).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </span>
                </div>
                {/* <div className="d-flex mt-1">
                  <span className="fw-bold">
                    {commonENLabels.NEW_APPLICATION.Last_Date_Fees}
                  </span>
                  <span>
                    {advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement &&
                      advertisementDetailsInfo.data.advertisement
                        .challanPaymentEndDate
                      ? dayjs(
                        advertisementDetailsInfo.data.advertisement
                          .challanPaymentEndDate
                      ).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </span>
                </div> */}
                <div className="d-flex mt-1">
                  <span className="fw-bold">
                    {commonENLabels.NEW_APPLICATION.Fees_Applicable}
                  </span>
                  <span>{applicationFee}</span>
                </div>
              </div>
              <div className="row mt-5">
                <div className="d-flex">
                  <span className="fw-bold">
                    {commonHILabels.NEW_APPLICATION.Start_Date_Application}
                  </span>
                  <span>
                    {advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement &&
                      advertisementDetailsInfo.data.advertisement.applnStartDate
                      ? dayjs(
                        getFormattedDate(advertisementDetailsInfo.data.advertisement
                          .applnStartDate)
                      ).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </span>
                </div>
                <div className="d-flex mt-1">
                  <span className="fw-bold">
                    {commonHILabels.NEW_APPLICATION.Last_Date_Application}
                  </span>
                  <span>
                    {advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement &&
                      advertisementDetailsInfo.data.advertisement.applnEndDate
                      ? dayjs(
                        getFormattedDate(advertisementDetailsInfo.data.advertisement
                          .applnEndDate)
                      ).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </span>
                </div>
                {/* <div className="d-flex mt-1">
                  <span className="fw-bold">
                    {commonHILabels.NEW_APPLICATION.Last_Date_Fees}
                  </span>
                  <span>
                    {advertisementDetailsInfo.data &&
                      advertisementDetailsInfo.data.advertisement &&
                      advertisementDetailsInfo.data.advertisement
                        .challanPaymentEndDate
                      ? dayjs(
                        advertisementDetailsInfo.data.advertisement
                          .challanPaymentEndDate
                      ).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </span>
                </div> */}
                <div className="d-flex mt-1">
                  <span className="fw-bold">
                    {commonHILabels.NEW_APPLICATION.Fees_Applicable}
                  </span>
                  <span>{applicationFee ? applicationFee : "-"}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="box-contents tab_container_box m-3 pt-1 pb-0">
            {/* <h6>
              {commonENLabels.NEW_APPLICATION.POST +
                " " +
                commonHILabels.NEW_APPLICATION.POST}
            </h6> */}
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className=" btn btn-primary custom_button  btn-bg-cust mb-2  "
                onClick={() => {
                  checkEligibility();
                }}
                disabled={
                  setCheckEligibilty === false
                    ? eligibilityResultList !== null
                    : true
                }
              >
                {commonENLabels.COMMON.ELIGIBILITY}
              </button>
            </div>
            {/* <div className="my-2 full-width-bottom-blue-border mt-4"></div>
            {advertisementDetailsInfo?.data?.examPostList?.map((examPost) => (
              <div key={examPost.id} className="card">
                <div className="card-header post-card-head">
                  <div className="row">
                    <div className="col-md-6">
                      <span>{examPost?.postCriteria?.name}</span>
                      <div>({examPost?.postCriteria?.nameDvng})</div>
                    </div>
                    <div className="col-md-6">
                      {getElibilityIndicator(examPost?.postCriteria?.id)}
                    </div>
                  </div>
                </div>
                <div className="card-body pre-wrap">
                  {examPost?.postCriteria?.description}
                </div>
              </div>
            ))} */}
          </div>

          {/* {eligibilityResultList != null &&
              applicationPostPrefList?.length != 0 &&
              applicableAdditionalQuestionsList &&
              applicableAdditionalQuestionsList?.length != 0 && (
                <div className="box-contents tab_container_box m-3">
                   <h6>
                    {advertisementDetailsLabel.QUESTIONS}
                  </h6>
                  <div className="my-2 full-width-bottom-blue-border mt-2"></div>

                  <QuestionDetails
                    additionalAnswers={additionalAnswers}
                    handleQuestions={handleQuestions}
                    isNext={isNext}
                  />
                </div>
              )} */}
          <div>
            <ProfileDetails
              allDeclAccepted={allDeclAccepted}
              setAllDeclAccepted={setAllDeclAccepted}
              advertisementDetailsInfo={advertisementDetailsInfo}
              eligibilityResultList={eligibilityResultList}
              applicationPostPrefList={applicationPostPrefList}
              applicableAdditionalQuestionsList={applicableAdditionalQuestionsList}
              additionalAnswers={additionalAnswers}
              additionalAnswersState={additionalAnswersState}
              handleQuestions={handleQuestions}
              isNext={isNext}
              handlePrefChange={handlePrefChange}
              movePostPrefDown={movePostPrefDown}
              movePostPrefUp={movePostPrefUp}
              handleMenuClick={handleMenuClick}
              handleOptionsChange={handleOptionsChange}
              formatGroupLabel={formatGroupLabel}
              InputOption={InputOption}
              someOptionsThisPost={someOptionsThisPost}
              showReviewDepartmentModal={showReviewDepartmentModal}
              doNext={doNext}
              selectedOptionErr={selectedOptionErr}
              resetPref={resetPref}
              uploadedDocumentData={uploadedDocumentData}
              handleDocChange={handleDocChange}
              handleDocumentListShow={handleDocumentListShow}
              onChangeDocument={onChangeDocument}
              viewDocument={viewDocument}
              isCenterSelection={isCenterSelection}
              maxCenterSelectionNumber={maxCenterSelectionNumber}
              selectedExamCenters={selectedExamCenters}
              setSelectedExamCenters={setSelectedExamCenters}
              examCenterOptionList={examCenterOptionList}
              goBack={goBack}
              onApply={onApply}
              uploadLiveImage={uploadLiveImage}
              isCameraOn={isCameraOn}
              setShowName={setShowName}
              showName={showName}
              ImageCropper={ImageCropper}
              errorLivePhoto={errorLivePhoto}
              takePhoto={takePhoto}
              webcamRef={webcamRef}
              capture={capture}
              removeCandidateLiveImage={removeCandidateLiveImage}
              setIsCameraOn={setIsCameraOn}
              showLiveImageCropper={showLiveImageCropper}
              deptOptions={deptOptions}
              popupName={popupName}
              setShowSuccessLivePhotoModal={setShowSuccessLivePhotoModal}
              showSuccessLivePhotoModal={showSuccessLivePhotoModal}
              hideModal={hideModal}
              timer={timer}
              isCheckboxMarked={isCheckboxMarked}
              SetIsCheckboxMarked={SetIsCheckboxMarked}
              setName={setName}
              applicationFee={applicationFee}
              applicationFeeWithoutConcession={applicationFeeWithoutConcession}
            />
          </div>
        </div>

        {/* <div className="col-md-2 ps-0"> */}
        {/* <div className="card f11 tab_container_box mt-3">
            <div className="card-body">
              <span>{commonENLabels.NEW_APPLICATION.Before_Applying_PDF}</span>
              <div className="mt-2">
                <span>
                  {commonHILabels.NEW_APPLICATION.Before_Applying_PDF}
                </span>
              </div>
              <div>
                <button
                  type="button"
                  className=" btn btn-primary custom_button  m-1 btn-bg-cust  "
                  onClick={() => {
                    downloadPdfFile();
                  }}
                >
                  {common.Download_PDF}
                </button>
              </div>
            </div>
          </div> */}
        {/* {eligibilityResultList != null &&
            applicationPostPrefList?.length != 0 && (
              <>
                <div className="card f11 tab_container_box mt-2">
                  <div className="card-header border_btm_blue9">
                    <span className="fw-bold">
                      {commonENLabels.NEW_APPLICATION.Select_and_apply}
                    </span>
                    <br />
                  </div>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <span>
                        {advertisementDetailsLabel.EligibleFollowingPost}
                      </span>
                    </li>
                    {applicationPostPrefList?.map((postPref, index) => (
                      <div>
                        <li
                          className={`list-group-item post-pref-item d-flex ${
                            index == applicationPostPrefList.length - 1 &&
                            "border_bottom_10"
                          }`}
                        >
                          <div className="flex-grow-1">
                            <input
                              className="d-inline-block"
                              type="checkbox"
                              name="isInterested"
                              checked={postPref.isInterested}
                              onChange={(event) =>
                                handlePrefChange(
                                  postPref,
                                  "isInterested",
                                  event.target.checked,
                                  postPref.postCriteriaId
                                )
                              }
                              disabled={isNext}
                            />{" "}
                            &nbsp;
                            <span>
                              {getPostName(postPref.postCriteriaId)}
                            </span>{" "}
                            <br /> &nbsp; &nbsp; &nbsp;
                            <span className="w65">
                              {getPostName(postPref.postCriteriaId, true)}
                            </span>
                          </div>
                          <div className="arrange-arrows d-flex flex-column justify-content-between">
                            <div>
                              {index > 0 && (
                                <i
                                  className="fa fa-arrow-up"
                                  onClick={() => movePostPrefUp(index)}
                                  mtitle="Move Up"
                                ></i>
                              )}
                            </div>
                            <div>
                              {index < applicationPostPrefList.length - 1 && (
                                <i
                                  className="fa fa-arrow-down"
                                  onClick={() => movePostPrefDown(index)}
                                  title="Move Down"
                                ></i>
                              )}
                            </div>
                          </div>
                        </li>
                        {postPref.isInterested === true &&
                          postPref.isAssignAuthority === true && (
                            <div className="card-body">
                              <div className="pad_0 btn-dropdown">
                                <Select
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  openMenuOnClick={handleMenuClick()}
                                  placeholder={
                                    advertisementDetailsLabel.APPOINTING_AUTHORITIES
                                  }
                                  onChange={(options) => {
                                    handleOptionsChange(
                                      options,
                                      postPref.postCriteriaId
                                    );
                                  }}
                                  formatGroupLabel={formatGroupLabel}
                                  options={[
                                    {
                                      label:
                                        advertisementDetailsLabel.MUMBAI_APPOINTING_AUTHORITIES,
                                      options: deptOptions
                                        .filter(
                                          (ele) =>
                                            ele.pid == postPref.postCriteriaId
                                        )
                                        .map((elem) => elem.options.mumbai)[0],
                                    },
                                    {
                                      label:
                                        advertisementDetailsLabel.OTHER_THAN_MUMBAI_APPOINTING_AUTHORITIES,
                                      options: deptOptions
                                        .filter(
                                          (ele) =>
                                            ele.pid == postPref.postCriteriaId
                                        )
                                        .map(
                                          (elem) => elem.options.outsideMumbai
                                        )[0],
                                    },
                                  ]}
                                  controlShouldRenderValue={false}
                                  isOptionDisabled={(option) =>
                                    option.isDisable
                                  }
                                  components={{
                                    Option: InputOption,
                                  }}
                                />
                                {someOptionsThisPost &&
                                someOptionsThisPost.indexOf(
                                  postPref.postCriteriaId
                                ) == -1 ? (
                                  <p className="errorText">
                                    {
                                      advertisementDetailsLabel.PLEASE_SELECT_APPOINTING_AUTHORITY
                                    }
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                              <button
                                type="button"
                                className=" btn btn-primary custom_button  btn-bg-cust button_reset_apply review_btn_css  "
                                onClick={() =>
                                  showReviewDepartmentModal(
                                    postPref.postCriteriaId
                                  )
                                }
                              >
                                {
                                  advertisementDetailsLabel.REVIEW_SELECTED_APPOINTING_AUTHORITIES
                                }
                              </button>
                              &nbsp;
                            </div>
                          )}
                      </div>
                    ))}
                  </ul>
                </div>
              </>
            )} */}
        {/* {eligibilityResultList != null &&
            applicationPostPrefList?.length == 0 && (
              <div className="card f11 tab_container_box  mt-2">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <span>
                      {
                        advertisementDetailsLabel.YOU_ARE_NOT_ELIGIBLE_FOR_ANY_POST
                      }
                    </span>
                  </li>
                </ul>
              </div>
            )} */}
        {/* {eligibilityResultList != null &&
            applicationPostPrefList?.length != 0 &&
            !isNext && (
              <>
                <button
                  type="button"
                  className="btn btn-outline-dark button_reset_apply"
                  onClick={resetPref}
                >
                  {common.RESET}
                </button>
                <button
                  type="button"
                  className=" btn btn-primary custom_button  btn-bg-cust btn button_reset_apply  "
                  disabled={selectedOptionErr === false ? true : false}
                  onClick={doNext}
                >
                  {common.APPLY}
                </button>
              </>
            )}
          {isNext && (
            <>
              {uploadedDocumentData && uploadedDocumentData.length > 0 ? (
                <div className="card f11 tab_container_box mt-2">
                  <div className="card-header border_btm_blue9 pe-0">
                    <span className="fw-bold">
                      {advertisementDetailsLabel.Upload_select_documents}{" "}
                      <span className="redColor">*</span>
                    </span>
                  </div>
                  <span className="noteColor p-2">
                    {advertisementDetailsLabel.CONFIRM_UPLOAD_DOCUMENT_NOTE}{" "}
                  </span>

                  <div className="card-body">
                    <div className="pad_0 btn-dropdown">
                      {uploadedDocumentData &&
                        uploadedDocumentData.map((doc, i) => (
                          <ul key={i} className="list-group mb-1">
                            <li
                              className={`list-group-item post-pref-item d-flex ${
                                i == uploadedDocumentData.length - 1 &&
                                "border_bottom_10"
                              }`}
                            >
                              <div className="flex-grow-1">
                                <input
                                  className="d-inline-block me-1"
                                  type="checkbox"
                                  name="isUploaded"
                                  checked={doc.isUploaded}
                                  onChange={(event) =>
                                    handleDocChange(
                                      doc,
                                      "isUploaded",
                                      event.target.checked
                                    )
                                  }
                                  disabled={!doc.documentInfoId}
                                />
                                &nbsp;
                                <i
                                  className="fa fa-info-circle document_list_css"
                                  data-toggle="tooltip"
                                  title="Document List"
                                  aria-hidden="true"
                                  onClick={() =>
                                    handleDocumentListShow(
                                      doc.documentTypeDescription
                                    )
                                  }
                                ></i>
                                <span>{doc.documentTypeName}</span>
                                <div className="float-end">
                                  <input
                                    type="file"
                                    name="document"
                                    id={"document" + i}
                                    onChange={(event) =>
                                      onChangeDocument(event, doc)
                                    }
                                    className="d-none"
                                    accept="application/pdf"
                                  />
                                  {doc.documentInfoId ? (
                                    <label
                                      htmlFor={"document" + i}
                                      className="pointer-class"
                                    >
                                      {advertisementDetailsLabel.RE_UPLOAD}
                                    </label>
                                  ) : (
                                    <label
                                      htmlFor={"document" + i}
                                      className="pointer-class"
                                    >
                                      {advertisementDetailsLabel.UPLOAD}
                                    </label>
                                  )}
                                </div>
                                <br />
                                <div>
                                  {doc.documentInfoId ? (
                                    <button
                                      type="button"
                                      className="pointer-class mt-2"
                                      onClick={() => viewDocument(doc)}
                                    >
                                      {
                                        advertisementDetailsLabel.VIEW_UPLOADED_DOCUMENT
                                      }
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="text-danger ms37"
                                    >
                                      {advertisementDetailsLabel.NOT_UPLOADED}
                                    </button>
                                  )}
                                </div>
                              </div>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {isCenterSelection && <div className="card tab_container_box mt-2">
                <div className="card-header border_btm_blue9">
                  <span className="fw-bold">
                    {advertisementDetailsLabel.Select_exam_center}{" "}
                    <span className="redColor">*</span>
                  </span>
                </div>
                {maxCenterSelectionNumber ? (
                  <span className="noteColor p-2">
                    {" "}
                    {advertisementDetailsLabel.SELECT_NOTE} {maxCenterSelectionNumber}{" "}
                    {advertisementDetailsLabel.EXAM_CENTER}{" "}
                  </span>
                ) : (
                  ""
                )}
                <div className="card-body">
                  <div className="pad_0 btn-dropdown">
                    <Select
                      isMulti={true}
                      isOptionDisabled={() =>
                        maxCenterSelectionNumber
                          ? selectedExamCenters.length >= maxCenterSelectionNumber
                          : false
                      }
                      value={selectedExamCenters}
                      onChange={setSelectedExamCenters}
                      options={examCenterOptionList.filter(
                        (examCenter) => examCenter.isDeleted == false
                      )}
                    />
                    {selectedExamCenters && selectedExamCenters.length >= 1 ? (
                      ""
                    ) : (
                      <p className="errorText">
                        {advertisementDetailsLabel.SELECT_OPTIONS}
                      </p>
                    )}
                  </div>
                </div>
              </div>}
              {profileInfo &&
              profileInfo.personalInfoDto &&
              profileInfo.personalInfoDto.flgDivyang &&
              profileInfo.personalInfoDto.divyangPercentage >= 40 ? (
                <div className="card tab_container_box mt-2">
                  <div className="card-header border_btm_blue9">
                    <span className="fw-bold">
                      {advertisementDetailsLabel.BENCHMARK_DISABILITIES_DETAILS}
                    </span>
                  </div>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <label>
                        {advertisementDetailsLabel.DISABILITY_COMP_TIME}
                      </label>
                      <select
                        className="form-select"
                        name="disabilityCompTime"
                        value={flgDisabilityCompTime}
                        onChange={(event) =>
                          setFlgDisabilityCompTime(event.target.value)
                        }
                      >
                        <option key="" value="">
                          {advertisementDetailsLabel.SELECT}
                        </option>
                        {BOOLEAN_OPTION.map((ele, i) => {
                          return (
                            <option key={i} value={ele.value}>
                              {ele.label}
                            </option>
                          );
                        })}
                      </select>
                    </li>
                    <li className="list-group-item">
                      <label>
                        {advertisementDetailsLabel.DISABILITY_SCRIBE_REQ}
                      </label>
                      <select
                        className="form-select"
                        name="disabilityScribeReq"
                        value={flgDisabilityScribeReq}
                        onChange={(event) =>
                          setFlgDisabilityScribeReq(event.target.value)
                        }
                      >
                        <option key="" value="">
                          {advertisementDetailsLabel.SELECT}
                        </option>
                        {BOOLEAN_OPTION.map((ele, i) => {
                          return (
                            <option key={i} value={ele.value}>
                              {ele.label}
                            </option>
                          );
                        })}
                      </select>
                    </li>
                    <li className="list-group-item border_bottom_10">
                      <label>
                        {advertisementDetailsLabel.SCRIBE_ARRANGED_BY}
                      </label>
                      <select
                        className="form-select"
                        name="scribeArrangedBy"
                        value={scribeArrangedBy}
                        onChange={(event) =>
                          setScribeArrangedBy(event.target.value)
                        }
                      >
                        <option key="" value="">
                          {advertisementDetailsLabel.SELECT}
                        </option>
                        {SCRIBE_OPTION.map((ele, i) => {
                          return (
                            <option key={i} value={ele.value}>
                              {ele.label}
                            </option>
                          );
                        })}
                      </select>
                    </li>
                  </ul>
                </div>
              ) : (
                ""
              )}
              <div className="card tab_container_box mt-2">
                <div className="card-header border_btm_blue9">
                  <span className="fw-bold">
                    {advertisementDetailsLabel.Declaration}{" "}
                    <span className="redColor">*</span>
                  </span>
                </div>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <input
                      type="checkbox"
                      checked={declAccepted}
                      onChange={(event) =>
                        setDeclAccepted(event.target.checked)
                      }
                    />
                    &nbsp; I&nbsp;
                    {profileInfo && profileInfo.personalInfo
                      ? profileInfo.personalInfo.englishFullName
                      : "CANDIDATE FULL NAME"}
                    &nbsp;
                    <span>{advertisementDetailsLabel.DECLARATION}</span>
                  </li>
                  <li className="list-group-item">
                    <div>
                      {advertisementDetailsLabel.DATE}{" "}
                      {dayjs().format(commonLabels.DATE_FORMAT)}
                    </div>
                    <div className="d-flex text-center">
                      <span className="pe-2">
                        {advertisementDetailsLabel.Location}&nbsp;
                        <span className="redColor">*</span>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        value={location}
                        onChange={(event) => setLocation(event.target.value)}
                      />
                    </div>
                  </li>
                  <li className="list-group-item border_bottom_10">
                    <img
                      src={
                        profileInfo && profileInfo.signature
                          ? `data:image/png;base64,${profileInfo.signature}`
                          : ""
                      }
                      width="130"
                      height="60"
                    />
                  </li>
                  <li className="list-group-item border_bottom_10">
                  <div className="imageSection" >
            
                  {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ? <span className="removeCandidateImage" title={profileuploadphotosignature.REMOVE_PHOTO} onClick={removeCandidateLiveImage}>X</span> : ''}
              {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ?
                <img src={(uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) ? `${uploadLiveImage.showCandidatePhoto}` : `data:image/png;base64, ${uploadLiveImage.showCandidatePhotoBase64}`} width="145" height="120" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CANDIDATE_PHOTO} /> :
                ""}
                 {isCameraOn ?
            <div className="pb35">
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
              />
              <button type="button" className=" btn btn-primary custom_button  btn-sm  livePhotoBtn text-blue" onClick={capture}>{commonLabels.SET_IMAGE}</button>
              <button type="button" className="btn btn-secondary btn-sm  livePhotoBtn text-blue" onClick={() => { setIsCameraOn(false) }}>{commonLabels.CANCEL}</button>
            </div> : 
            <div className="pb36">
              <ImageCropper />
            </div>
              }
                {(errorLivePhoto != "" && (uploadLiveImage.showCandidatePhoto == "" || uploadLiveImage.showCandidatePhoto.length == null || uploadLiveImage.showCandidatePhoto.length == "") && uploadLiveImage.showCandidatePhotoBase64 == "") ? <span className='errorMsg'>{errorLivePhoto}</span> : ''}
              <button className=' btn btn-primary custom_button  mt-3 livePhotoBtn text-blue' onClick={takePhoto} >{profileuploadphotosignature.LIVE_PHOTO} <i className="fa fa-camera fa-lg m-1" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CAMERA}></i></button><br/> 
              {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ? <button className=' btn btn-primary custom_button  mt-1 livePhotoBtn text-blue' onClick={showLiveImageCropper}>{profileuploadphotosignature.LIVE_PHOTO_CROP} <i className="fa fa-crop fa-lg m-1"  aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CROP_PHOTO}></i> </button> : ''} 
           </div>
                  </li>

                </ul>
              </div>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm button_reset_apply"
                onClick={goBack}
              >
                {common.CANCEL}
              </button>
              <button
                type="button"
                className=" btn btn-primary custom_button  btn-bg-cust btn-sm button_reset_apply"
                onClick={onApply}
                disabled={
                  !(
                    declAccepted &&
                    allDeclAccepted &&
                    location &&
                    // selectedExamCenters.length > 0 &&
                    (!(isCenterSelection  && selectedExamCenters.length <= maxCenterSelectionNumber))&&
                    selectedOptionErr
                  )
                }
              >
                {common.SUBMIT_AND_FEES}
              </button>
            </>
          )} */}
        {/* </div> */}
      </div>
      <Modal show={proceedToPayment} backdrop="static">
        <form>
          <Modal.Header className="logout_heading">
            <Modal.Title className="logout_title">{myAccountLabels.SELECT_PAYMENT_MODE}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <span>{advertisementDetailsLabel.APPLICATION_SAVE_NOTE}</span>{" "}
                <br />
                <br />
                {showChallan ? (
                  <div className="input-group h-auto">
                    <label className="position-relative mb-1">
                      <input
                        type="radio"
                        className="radio"
                        name="paymenttype"
                        value="challan_payment"
                        disabled={
                          challanDownloadDate &&
                          dayjs(challanDownloadDate).isBefore(new Date(), "day")
                        }
                        ref={register({ required: true })}
                      />
                      &nbsp;{advertisementDetailsLabel.Challan_Payment}
                    </label>
                    <span className="ps-4">
                      {
                        advertisementDetailsLabel.DOWNLOAD_AND_PRINT_CHALLAN_NOTE
                      }{" "}
                      &nbsp;
                      {challanDownloadDate
                        ? dayjs(challanDownloadDate).format(
                          commonLabels.DATE_FORMAT
                        )
                        : ""}
                      . {advertisementDetailsLabel.CHALLAN_PAYMENT_NOTE} &nbsp;
                      {applyedApplication?.challanPaymentEndDate
                        ? dayjs(
                          getFormattedDate(applyedApplication.challanPaymentEndDate)
                        ).format(commonLabels.DATE_FORMAT)
                        : ""}
                      .
                    </span>
                  </div>
                ) : (
                  ""
                )}
                <br />
                {showOnlinePayment ? (
                  <div className="input-group h-auto">
                    <label className="position-relative mb-1">
                      <input
                        type="radio"
                        className="radio"
                        name="paymenttype"
                        value="online_payment"
                        disabled={
                          applyedApplication &&
                          dayjs(
                            applyedApplication.onlinePaymentEndDate
                          ).isBefore(new Date(), "day")
                        }
                        ref={register({ required: true })}
                      />
                      &nbsp;{advertisementDetailsLabel.Online_Payment}
                    </label>
                    <span className="ps-4">
                      {advertisementDetailsLabel.ONLINE_PAYMENT_NOTE} &nbsp;
                      {applyedApplication &&
                        applyedApplication.onlinePaymentEndDate
                        ? dayjs(applyedApplication.onlinePaymentEndDate).format(
                          commonLabels.DATE_FORMAT
                        )
                        : ""}
                    </span>
                  </div>
                ) : (
                  ""
                )}
                <br />
                {watch("paymenttype") === "online_payment" ? (
                  <div className="ps-4">
                    {showSbi ? (
                      <div className="input-group">
                        <label className="position-relative mb-2">
                          <input
                            type="radio"
                            className="radio"
                            name="paymentBank"
                            value="sbi"
                            ref={register({ required: true })}
                          />
                          &nbsp;{commonLabels.SBI}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showBillDesk ? (
                      <div className="input-group">
                        <label className="position-relative mb-2">
                          <input
                            type="radio"
                            className="radio"
                            name="paymentBank"
                            value="billdesk"
                            ref={register({ required: true })}
                          />
                          &nbsp;{commonLabels.BILL_DESK}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showCsc ? (
                      <div className="input-group">
                        <label className="position-relative mb-2">
                          <input
                            type="radio"
                            className="radio"
                            name="paymentBank"
                            value="csc"
                            ref={register({ required: true })}
                          />
                          &nbsp;{commonLabels.CSC}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showEaseBuzz ? (
                      <div className="input-group">
                        <label className="position-relative mb-2">
                          <input
                            type="radio"
                            className="radio"
                            name="paymentBank"
                            value="easebuzz"
                            ref={register({ required: true })}
                          />
                          &nbsp;{commonLabels.EASEBUZZ}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showQuickwallet ? (
                      <div className="input-group">
                        <label className="position-relative mb-2">
                          <input
                            type="radio"
                            className="radio"
                            name="paymentBank"
                            value="quickPayWallet"
                            ref={register({ required: true })}
                          />
                          &nbsp;{commonLabels.QUICK_WALLET}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className=" btn btn-primary custom_button   "
              disabled={!formState.isValid}
              onClick={() => {
                processToPayment(applyedApplication, watch("paymenttype"));
              }}
            >
              {commonLabels.OK}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <DocumentList
        showModal={showDocListModal}
        setshowDocList={setshowDocListModal}
        docData={singleDocList}
      />
      {reviewDepartmentModal && (
        <ReviewSelectedModal
          showModal={reviewDepartmentModal}
          setReviewDepartmentModal={setReviewDepartmentModal}
          currentPostId={currentPostId}
          options={selectedDepartmentArr}
        />
      )}
    </div>
  );
};

export default AdvertisementDetails;
